<template>
  <!-- 职位管理 -->
  <div v-loading="loading">
    <div class="content">
      <div class="s_wrapper">
        <!-- 输入搜索 -->
        <el-input class="s_input" placeholder="搜索职务名称" suffix-icon="el-icon-search" v-model="positionName " clearable @change="onCurrentPage"></el-input>
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </div>
      <!-- 表格 -->
      <div class="g_table tableBox">
        <el-table max-height="540" :data="tableData">
          <el-table-column label="序号" min-width="60">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column prop="positionName" label="职务名称" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button type="primary" plain size="small" @click="handleEdit(scope.row)">修改</el-button>
              <el-button size="small" type="danger" @click="handleDel(scope.row)" plain>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination>
    </div>
    <!-- 弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
        <el-form-item label="职务名称" prop="positionName">
          <el-input v-model.trim="ruleForm.positionName" placeholder="请输入职务名称" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" :loading="dialogLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      // 表格数据
      tableData: [],
      dialogVisible: false, //弹窗隐显
      dialogLoading: false, //弹窗按钮Loading
      dialogTitle: "", //弹窗标题
      ruleForm: {
        positionName: "", //职务名称 
      },

      rules: {
        positionName: [{ required: true, message: "请输入门店名称", trigger: "blur" }],
      },
      // 分页器
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50],
      totalCount: 0, // 总记录数据
      positionName: "", //职务名称
      positionId: ''
    }
  },
  created() {
    this.getRequest() //请求数据
  },
  methods: {
    // 请求
    getRequest() {
      this.loading = true
      this.$axios.get(this.$api.positionInfoSelect, {
        params: {
          positionName: this.positionName, //门店名称
          page: this.currentPage,
          pageSize: this.pageSize,
        },
      }).then(res => {
        const { code, result } = res
        if (code == 100) {
          this.totalCount = result.totalCount
          this.tableData = result.list
          this.loading = false
        }
      }).catch(err => {
        this.$message.error(err.desc)
        this.loading = false
      })
    },
    // 新增
    handleAdd() {
      this.ruleForm = {}
      this.dialogTitle = "新增"
      this.dialogVisible = true
    },
    // 提交信息
    async submitForm(formName) {
      try {
        // 校验表单
        await new Promise((resolve, reject) => {
          this.$refs[formName].validate(valid => {
            if (!valid) {
              this.$message.error("请检查职务名称是否漏填！")
              this.dialogLoading = false
              return
            } else {
              resolve() // 校验成功
            }
          })
        })
        // 要发送的数据
        const data = {
          positionName: this.ruleForm.positionName,
          positionId: this.positionId || null,
        }
        // console.log(data);
        // 根据状态决定是添加还是修改
        let response
        let message
        if (this.dialogTitle == "新增") {
          message = "恭喜你，新增成功!"
          response = await this.$axios.post(this.$api.positionInfoInsert, {
            positionName: this.ruleForm.positionName,
          })
        } else {
          message = "恭喜你，修改成功!"
          response = await this.$axios.post(this.$api.positionInfoUpdate, data)
        }

        // 处理响应结果
        const { code } = response
        if (code == 100) {
          this.onCurrentPage() // 调取列表数据
          this.loading = false
          this.$message({ message: message, type: "success" })
          this.dialogLoading = false
          this.dialogVisible = false
          this.resetForm() // 重置校验
        }
      } catch (err) {
        this.$message.error(err.desc)
        this.loading = false
      }
    },
    // 取消按钮
    handleCancel() {
      this.dialogVisible = false
      this.resetForm()
    },

    // 表单重置
    resetForm() {
      this.ruleForm = {}
      this.$refs.ruleForm.resetFields()
    },
    // 删除
    handleDel(row) {
      this.$confirm("此操作将永久删除该职务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.$axios.post(`${this.$api.positionInfoDelete}/${row.positionId}`)
          .then(res => {
            if (res.code == 100) {
              this.onCurrentPage()
              this.$message.success("删除成功！")
            }
          }).catch(err => {
            this.$message.error(err.desc)
          })
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除操作",
        })
      })
    },
    //修改
    handleEdit(row) {
      // console.log(row);
      this.dialogTitle = "修改"
      this.ruleForm = Object.assign({}, row)
      this.positionId = row.positionId
      this.dialogVisible = true
    },
    // 分页器
    onCurrentPage() {
      this.tableData = []
      this.currentPage = 1
      this.getRequest()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.onCurrentPage()
    },
    handleCurrentChange(val) {
      this.tableData = []
      this.currentPage = val
      this.getRequest()
    },
  },
}
</script>

<style scoped lang="scss">
.pagination {
  margin-top: 20px;
}

.content {
  .el-input,
  .el-select {
    width: 180px;
    margin-left: 10px;
    // margin-bottom: 20px;
  }

  .el-date-editor {
    margin-left: 10px !important;
  }

  .header-btn {
    margin-left: 10px;
  }
}

.tableBox {
  overflow: auto;

  ::v-deep .el-table--group::after,
  .el-table--border::after,
  .el-table::before {
    content: "";
    position: absolute;
    background-color: #ebeef5;
    opacity: 0;
  }

  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px;
    /*滚动条宽度*/
    height: 4px;
    /*滚动条高度*/
  }
}

/*操作下拉框内容*/
.el-dropdown-link {
  cursor: pointer;
}

::v-deep .el-dialog .el-input,
::v-deep .el-dialog .el-input__inner {
  width: 400px;
}
</style>
